export default __webpack_public_path__ + "static/media/hacksaw.fa4d7357.png";